
import { AssetMetadataBase } from './asset.metadata.base';


export class AssetMetadata extends AssetMetadataBase {
  constructor() {
    super();
  }
}

export const ASSET_METADATA: AssetMetadata = new AssetMetadata();


